const BASE_URL = process.env.REACT_APP_API_URL || "https://admin.mylibrary.lk/api/api/web";
const PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=com.iamkw97.mylibraryv3&pcampaignid=web_share';

export { BASE_URL, PLAYSTORE_URL };